import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { pageCount, shouldShowControls, resolveTotal } from "../pagination";
import { SPINNER_FADEOUT_DURATION } from "../app.constants";
import { LoginService } from "../login.service";
import { PatientsService } from "../patients.service";
import { Patient } from "./patient";
import { ExamsService } from "../exams.service";
import { Router } from "@angular/router";
import { Subject, Subscription } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";
import { GastroFormsService } from "../gastro-forms.service";
import { GastroService } from "../gastro.service";
import { SitesService } from "../sites.service";
import * as XLSX from "xlsx";
import { DatePipe } from "@angular/common";
import { writeFile } from "xlsx";

@Component({
    selector: "app-patients",
    templateUrl: "./patients.component.html",
    styleUrls: ["./patients.component.scss"],
    standalone: false
})
export class PatientsComponent implements OnInit, OnDestroy {
  @ViewChild("swipeField") swipeField: ElementRef;
  showExcel = false;
  showprintopts = false;
  showprint = false;
  inform = false;
  id: string;
  first: string;
  last: string;
  phone: string;
  idp = 1;
  showhelp: boolean = false;
  selectedPatient: Patient;
  formSelected: any;
  invalidi: string = "";
  invalidf: string = "";
  invalidl: string = "";
  patList: Patient[];
  isAWL = false;
  AWLStatus = "Waiting";
  AWLExam = "All";
  location = null;
  AWLlist: Patient[];
  // Sites cross-clinic TodayList (interpreting doctor aggregates all their sites)
  crossMode = false;
  siteFilter: number | null = null;
  private siteFilterInitialized = false;
  showSiteStats = false;
  siteCounts: any[] = [];
  siteStatsLoading = false;
  xmlList;
  examList;
  patientsearch = true;
  fromd: Date;
  tod: Date;
  openEsearch = false;
  isReports = false;
  hmostype;
  exams;
  typeForm;
  examMode = "All";
  examNames = [
    "FOV",
    "OCT",
    "OCTOptic",
    "OCTMacular",
    "TOPEye",
    "Pachymetry",
    "Fundus",
  ];
  eyesTodayListExams = [];
  reportsNames = ["Refferelnum", "Clalit", "HMO", "AllReports"];
  examVals = {};
  chosenAWL: number;
  awlTime: string;
  awlExamType: string;
  awlLMP;
  awlComment: string;
  prn: string;
  code: string;
  swiping = false;
  card: string;
  idcode: string;
  carderror: string;
  expcode: string;
  GA;
  GaArray: any[] = [];
  patExams: any[] = [];
  visitPat: any[] = [];
  showpayment: string;
  cardtzsearch: string;
  goEx = { preg: null, exam: null, etype: null };
  showLogin = false;
  startClinic: number;
  private destroy$ = new Subject();
  private searchDebounce$ = new Subject<void>();
  private searchSub: Subscription;
  currentPage: number = 1;
  pageSize: number = 25;
  totalResults = 0;
  showPaginationControls: boolean = false;
  get totalPages(): number {
    return pageCount(this.totalResults, this.pageSize);
  }
  searchLoading = false;
  examListLoading = false;
  // Set true for the SPINNER_FADEOUT_DURATION window right before the loading flag clears, so the spinner fades out instead of popping away.
  searchFading = false;
  examListFading = false;
  // Interpreted/Completed TodayList statuses are paginated server-side (see
  // AWL()/search()); kept separate from currentPage/hasMore/pageSize above
  // since that's a different list (Patient Search: currentPage/totalResults),
  // with its own page size.
  awlPage: number = 1;
  awlPageSize: number = 15;
  awlHasMore: boolean = false;
  sub = new Subscription();
  startdate;
  enddate;
  changedExamCode;
  reportName = null;
  sentMacabi = false;
  openConcentForm;
  concentForm;
  last_search_time;
  toreassign;
  xmlLoading = false;
  showDownLoad = false;
  showSendQuestionnaire = false;
  sendQuestionnairePatient: any = null;
  patQuestionnaireAnswered: { [awlid: number]: boolean } = {};

  constructor(
    public gs: GastroService,
    public loginService: LoginService,
    public patservice: PatientsService,
    public exServ: ExamsService,
    private rt: Router,
    public gfs: GastroFormsService,
    private datePipe: DatePipe,
    private http: HttpClient,
    public sites: SitesService,
  ) {
    this.loginService.loginMissing();
    this.id = "";
    this.first = "";
    this.last = "";
    this.phone = "";

    for (let e of this.examNames) this.examVals[e] = true;
  }

  clear() {
    this.id = "";
    this.first = "";
    this.last = "";
    this.phone = "";
    if (this.isAWL) this.search();
  }

  async ngOnInit() {
    // Debounce keyup-driven searches so we query once per pause in typing,
    // not once per keystroke (each search is a heavy DB query).
    this.searchDebounce$
      .pipe(debounceTime(400), takeUntil(this.destroy$))
      .subscribe(() => this.runSearch());
    // Keep the TodayList's own site filter in sync with the global clinic
    // switcher whenever it changes (not just at initial load) — a manual local
    // override still works in between global switches, it just resets on the
    // next one, same as everywhere else session GID changes take precedence.
    // Patient Search / Exam Search have no local filter of their own, so a
    // switch there just re-runs whichever search is currently showing — it
    // picks up the new scope (specific site or "all") the same way the initial
    // search would have.
    this.sites.activeSiteChanged$
      .pipe(takeUntil(this.destroy$))
      .subscribe((site) => {
        if (this.isAWL && this.crossMode) {
          this.siteFilter = typeof site === "number" ? site : null;
          this.AWL(false);
        } else if (!this.isAWL && this.patList) {
          this.search();
        } else if (!this.isAWL && this.examList && !this.isReports) {
          this.examSearch();
        }
      });
    this.AWLExam = "All";
    let now = new Date();
    let ndate =
      now.getFullYear() +
      "-" +
      (now.getMonth() + 1 < 10 ? "0" : "") +
      (now.getMonth() + 1) +
      "-" +
      (now.getDate() < 10 ? "0" : "") +
      now.getDate();
    now = new Date(ndate);
    this.tod = now;
    this.fromd = now;
    if (this.loginService.showAWL()) {
      if (this.loginService.lastAwl) {
        this.AWLStatus = this.loginService.lastAwl;
      }
      if (this.loginService.lastAwlExam)
        this.AWLExam = this.loginService.lastAwlExam;
      if (
        this.loginService.lastAwlStartDate &&
        this.loginService.lastAwlEnDate
      ) {
        this.startdate = this.loginService.lastAwlStartDate;
        this.enddate = this.loginService.lastAwlEnDate;
      }

      switch (this.loginService.userType) {
        case "doctor":
          this.AWLStatus = "Completed";

          break;
        case "tech":
          this.AWLStatus = "Received";

          break;

        default:
          this.AWLStatus = "Waiting";
          break;
      }

      if (!this.exServ.searchReport) this.AWL();
    }
    this.loginService.onLogin.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (
        (this.goEx.preg && this.goEx.exam && this.goEx.etype) ||
        (this.goEx &&
          (this.loginService.isGastro || this.loginService.isCardio))
      ) {
        this.exServ.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype);
      }
    });
    this.patservice.exitFromGastroExam.subscribe(() => {
      this.AWLStatus = this.patservice.AWLStatus;
      this.loginService.lastAwl = "All";
    });
    this.patservice.awlIncomming
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        if (this.isAWL) this.AWL();
      });
    // Sites: any site's awl socket changing refreshes the aggregated list.
    this.sites.changed$.pipe(takeUntil(this.destroy$)).subscribe(() => {
      if (this.isAWL && this.crossMode) this.search();
    });
    if (this.exServ.searchReport) {
      this.fromd = this.exServ.searchReport.start;
      this.tod = this.exServ.searchReport.end;
      this.reportName = this.exServ.searchReport.type;
      this.hmostype = this.exServ.searchReport.hmo;
      this.isReports = true;
      this.AWLlist = null;
      this.searchClosed([
        this.fromd,
        this.tod,
        [],
        this.reportName,
        this.hmostype,
      ]);
      // this.examSearch(this.reportName, this.hmostype);
    }
    this.sub = this.loginService.export$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data) => {
        if (!data) {
          this.exServ.searchReport = null;
        }
      });
  }

  get examTypes(): Array<string> {
    const premissions = this.loginService.premissions;
    if (!premissions) return ["FOV", "OCT", "FOV + OCT", "Pachymetry"];
    const examTypes = [];
    const { OCTOptic, OCTMacular, FOV, TOPEye, Pachymetry, Fundus } =
      this.loginService.premissions!;

    if (!OCTOptic && !OCTMacular) {
      examTypes.push("OCT");
    }

    if (OCTOptic) {
      examTypes.push("OCT Optic");
    }

    if (OCTMacular) {
      examTypes.push("OCT Macular");
    }

    if (FOV && !OCTMacular && !OCTOptic) {
      examTypes.push("FOV + OCT");
    }

    if (FOV) {
      examTypes.push("FOV");
    }

    if (TOPEye) {
      examTypes.push("TOP");
    }

    if (Pachymetry) {
      examTypes.push("Pachymetry");
    }

    if (Fundus) {
      examTypes.push("Fundus");
    }

    if (OCTOptic && OCTMacular) {
      examTypes.push("OCT Opt + OCT Mac");
    }

    if (OCTOptic && OCTMacular && FOV) {
      examTypes.push("OCT Opt + OCT Mac + FOV");
    }

    if (OCTOptic && TOPEye) {
      examTypes.push("OCT Opt + TOP");
    }

    if (OCTOptic && FOV) {
      examTypes.push("OCT Opt + FOV");
    }

    if (OCTOptic && OCTMacular && FOV && Pachymetry) {
      examTypes.push("OCT Opt + OCT Mac + FOV + Pachymetry");
    }

    return examTypes;
  }

  addPatient() {
    // No single clinic to create into while the global switcher is on "all" —
    // the button is disabled for this too, this is just defense in depth.
    if (this.sites.activeSite === "all") return;
    this.invalidi = "";
    if (this.id.length < 7) {
      this.invalidi = "is-invalid";
      return;
    }
    this.invalidf = "";
    if (this.first == "") {
      this.invalidf = "is-invalid";
      return;
    }
    this.invalidl = "";
    if (this.last == "") {
      this.invalidl = "is-invalid";
      return;
    }
    this.selectedPatient = new Patient(
      this.id,
      this.first,
      this.last,
      this.phone,
    );
  }

  onClosed(closed: string) {
    if (closed) this.selectedPatient = null;
    if (closed == "awl") {
      this.clear();
      this.AWL();
    } else if (this.patList) this.search(); //to refresh details
    this.awlExamType = null;
    this.awlLMP = null;
    this.awlTime = null;
    this.chosenAWL = null;
    this.prn = null;
    this.code = null;
    this.typeForm = null;
  }

  search(noawl = false) {
    this.examList = null;
    this.xmlList = null;
    this.exServ.searchReport = null;
    this.isReports = false;
    this.carderror = null;
    // Resets to the first page on new search
    this.currentPage = 1;
    this.showPaginationControls = false;
    this.searchLoading = true;
    // Cancel any in-flight search so a slower older response can't
    // overwrite the results of a newer one (and to free the server).
    if (this.searchSub) this.searchSub.unsubscribe();
    if (this.isAWL && !noawl) {
      this.patList = null;
      if ((this.startdate, this.enddate)) {
        var start =
          this.startdate._i.year +
          "-" +
          (this.startdate._i.month + 1) +
          "-" +
          this.startdate._i.date +
          " 00:00:00.000";
        var end =
          this.enddate._i.year +
          "-" +
          (this.enddate._i.month + 1) +
          "-" +
          this.enddate._i.date +
          " 23:59:59.000";
      }
      const awlParams: any = {
        id: this.id,
        first: this.first,
        last: this.last,
        start: start,
        end: end,
        location: this.location,
      };
      if (this.crossMode) {
        // Cross-clinic shared pool: aggregate all the doctor's sites, no per-doctor
        // uid filter. Optional Site filter narrows to one site (validated server-side).
        awlParams.cross = "1";
        if (this.siteFilter) awlParams.site = String(this.siteFilter);
      } else {
        awlParams.uid = this.loginService.doctor;
      }
      // Interpreted and Completed (Waiting for Interpretation) are paginated
      // server-side (15/page) — see mssql.js getAWL(). Interpreted additionally
      // defaults to the last 30 days there; Completed stays unbounded by date
      // since it's the active work queue. Other statuses are small/live queues
      // and stay unpaginated.
      if (this.AWLStatus === "Interpreted" || this.AWLStatus === "Completed") {
        awlParams.page = this.awlPage;
        awlParams.pageSize = this.awlPageSize;
      }
      this.searchSub = this.patservice
        .getAWL(this.AWLStatus, this.AWLExam, awlParams)
        .subscribe(
          (patients: Patient[]) => {
            if (patients.length > 0) {
              this.GaArray = [];
              patients.forEach((i) => {
                var GAitem = this.lmpGA(i.ExamLMP);
                this.GaArray.push(GAitem);
                if (i.UID) i["nUID"] = i.UID;
              });
            }
            this.AWLlist = patients;
            this.awlHasMore =
              (this.AWLStatus === "Interpreted" || this.AWLStatus === "Completed") &&
              patients.length === this.awlPageSize;
            this.searchFading = true;
            setTimeout(() => {
              this.searchLoading = false;
              this.searchFading = false;
            }, SPINNER_FADEOUT_DURATION);
            this.loadQuestionnaireStatuses(patients);
            if (this.cardtzsearch) {
              this.swiping = false;
              for (let pat of this.AWLlist) {
                let zeros = pat.ID;
                while (zeros.length < 9) zeros = "0" + zeros;
                if (pat.ID == this.cardtzsearch || zeros == this.cardtzsearch) {
                  this.setAWL(pat);
                  this.selectedPatient = pat;
                  if (this.selectedPatient.HMO != "Macabi") {
                    //now for macabi only
                    this.selectedPatient.HMO = "Macabi";
                    this.patservice
                      .savePatient(
                        this.selectedPatient,
                        this.selectedPatient.PID,
                      )
                      .subscribe(
                        (data) => {},
                        (error) => {
                          console.log(error);
                        },
                      );
                  }
                  this.showpayment = this.cardtzsearch;
                  this.cardtzsearch = null;
                }
              }
              if (this.cardtzsearch) {
                this.carderror = this.cardtzsearch;
                this.cardtzsearch = null;
              }
            }
          },
          (error) => {
            console.log(error);
            this.searchFading = true;
            setTimeout(() => {
              this.searchLoading = false;
              this.searchFading = false;
            }, SPINNER_FADEOUT_DURATION);
          },
        );
    } else {
      this.AWLlist = null;
      // this.visitPat = null;
      this.searchSub = this.patservice.getPatients(
        this.id,
        this.first,
        this.last,
        this.phone,
        this.loginService.doctor,
        (patients: Patient[]) => {
          this.patList = [];
          this.isAWL = false;
          for (let i = 0; i < patients.length; i++) {
            let pat = new Patient();
            pat.asignVals(patients[i]);
            this.patList[i] = pat;
          }
          this.totalResults = resolveTotal(patients as any);
          this.showPaginationControls = shouldShowControls(this.totalResults, this.pageSize);
          this.searchFading = true;
          setTimeout(() => {
            this.searchLoading = false;
            this.searchFading = false;
          }, SPINNER_FADEOUT_DURATION);
        },
        this.currentPage,
        this.pageSize,
        this.sites.activeSite === "all",
        () => {
          // A failed request must still clear the spinner, or it spins forever.
          this.searchFading = true;
          setTimeout(() => {
            this.searchLoading = false;
            this.searchFading = false;
          }, SPINNER_FADEOUT_DURATION);
        }
      );
    }
    // }
  }

  nextPage() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.loadPatients();
    }
  }

  previousPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.loadPatients();
    }
  }

  loadPatients() {
    if (this.searchSub) this.searchSub.unsubscribe();
    this.searchLoading = true;
    this.searchSub = this.patservice.getPatients(
      this.id,
      this.first,
      this.last,
      this.phone,
      this.loginService.doctor,
      (patients: Patient[]) => {
        this.patList = [];
        for (let i = 0; i < patients.length; i++) {
          let pat = new Patient();
          pat.asignVals(patients[i]);
          this.patList[i] = pat;
        }
        this.totalResults = resolveTotal(patients as any);
        this.searchFading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchFading = false;
        }, SPINNER_FADEOUT_DURATION);
      },
      this.currentPage,
      this.pageSize,
      this.sites.activeSite === "all",
      () => {
        // A failed request must still clear the spinner, or it spins forever.
        this.searchFading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.searchFading = false;
        }, SPINNER_FADEOUT_DURATION);
      }
    );
  }

  trysearch() {
    this.id = (this.id || "").replace(/\-/g, "_").replace(/\W/g, "").replace(/_/g, "-");
    this.searchDebounce$.next();
  }

  private runSearch() {
    if (!this.isSearchDisabled())
      this.search(!this.loginService.ishospital); //for clinics search works on patients - not awl
    if (
      this.isAWL &&
      (this.id || "").length == 0 &&
      (this.first || "").length == 0 &&
      (this.last || "").length == 0
    )
      //when cleared
      this.search();
  }

  // Search gate: at least one field with 2+ characters. Shared by auto-search and the Search button.
  // Button gate: the content rule plus an in-flight check, so the button can't be spammed while a search is pending.
  // Kept separate from isSearchDisabled() so a request in flight never blocks the debounced auto-search.
  get isSearchButtonDisabled(): boolean {
    return this.searchLoading || this.isSearchDisabled();
  }

  isSearchDisabled(): boolean {
    return !(
      (this.id || "").trim().length > 1 ||
      (this.first || "").trim().length > 1 ||
      (this.last || "").trim().length > 1 ||
      (this.phone || "").trim().length > 1
    );
  }

  AWL(savestatus = true, type = null) {
    if (!this.enddate && this.startdate) {
      this.enddate = this.startdate;
    } else if (!this.startdate && this.enddate) {
      this.startdate = this.enddate;
    }
    if (savestatus) {
      this.loginService.lastAwlExam = this.AWLExam;
      this.loginService.lastAwl = this.AWLStatus;
      this.loginService.lastAwlStartDate = this.startdate;
      this.loginService.lastAwlEnDate = this.enddate;
    }
    this.isAWL = true;
    this.awlPage = 1;
    this.examList = null;
    this.xmlList = null;
    this.exServ.searchReport = null;
    // Sites: resolve the doctor's site clinics once (cached). If any, this is a
    // cross-clinic TodayList — aggregate across all sites and open one socket per
    // site. Otherwise behave exactly as the single-clinic TodayList does today.
    this.sites.loadSites().then((list) => {
      this.crossMode = list.length > 0 && this.loginService.userType === "doctor";
      // Start the TodayList's own (independent) site filter in sync with the
      // global clinic switcher — but only once, the first time crossMode turns
      // on. AWL() re-runs on every filter change (status/date/exam type, and
      // the local Site dropdown itself), so applying this unconditionally kept
      // silently snapping the user's own "All sites" pick back to whatever the
      // global switcher said. Later global-switcher changes are still picked up
      // via the activeSiteChanged$ subscription in ngOnInit.
      if (this.crossMode && !this.siteFilterInitialized && typeof this.sites.activeSite === "number") {
        this.siteFilterInitialized = true;
        this.siteFilter = this.sites.activeSite;
      }
      this.search();
      if (this.crossMode) {
        this.sites.openSockets(list.map((s) => s.GID));
      } else {
        this.patservice.openWebSocket(
          !this.loginService.ishospital ? this.loginService.ClinicID : null,
        );
      }
    });
  }

  nextAwlPage() {
    this.awlPage++;
    this.search();
  }

  previousAwlPage() {
    if (this.awlPage > 1) {
      this.awlPage--;
      this.search();
    }
  }

  switchSearch() {
    this.patientsearch = !this.patientsearch;
    if (!this.patientsearch) this.examSearch();
    else this.examList = [];
    this.xmlList = [];
  }

  examSearch(reportName = null, hmo = null) {
    this.isAWL = false;
    this.AWLlist = null;
    this.visitPat = null;
    this.patList = null;
    this.xmlList = null;
    this.examListLoading = true;
    if (reportName) {
      this.isReports = true;
      this.reportName = reportName;
      this.hmostype = hmo;
      this.exServ.searchReport = {
        start: this.fromd,
        end: this.tod,
        type: reportName,
        hmo: hmo,
      };
      this.exServ
        .reportSearch(
          this.fromd,
          this.tod,
          reportName,
          hmo,
          this.loginService.doctor,
        )
        .subscribe(
          (data) => {
            this.examList = data;
            this.examListFading = true;
            setTimeout(() => {
              this.examListLoading = false;
              this.examListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          },
          (error) => {
            console.log(error);
            this.examListFading = true;
            setTimeout(() => {
              this.examListLoading = false;
              this.examListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          },
        );
    } else {
      this.exServ.searchReport = null;
      this.isReports = false;
      this.exServ
        .examSearch(
          this.fromd,
          this.tod,
          this.examVals,
          this.loginService.doctor,
          this.sites.activeSite === "all",
        )
        .subscribe(
          (data) => {
            this.examList = data;
            this.examListFading = true;
            setTimeout(() => {
              this.examListLoading = false;
              this.examListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          },
          (error) => {
            console.log(error);
            this.examListFading = true;
            setTimeout(() => {
              this.examListLoading = false;
              this.examListFading = false;
            }, SPINNER_FADEOUT_DURATION);
          },
        );
    }
  }

  goPatient(exam, event?: MouseEvent) {
    // Exam search can surface rows from other sites when the global switcher is
    // on "all" — block on a clinic mismatch and let the user explicitly confirm
    // the switch, same as the cross-clinic TodayList does, so the patient lookup
    // below (which is itself GID-scoped) actually finds it.
    this.guardOpen(exam.GID, () => {
      this.patservice.getPatient(exam.PID, (s) => {
        if (s)
          this.rt.navigate(["/exams"], {
            state: { data: this.patservice.currentPatient },
          });
      });
    }, event);
  }

  // Search results (patient/exam) can include rows from other sites when the
  // global switcher is on "all" — block on a clinic mismatch instead of
  // silently switching (a patient/exam view fires many independently
  // clinic-scoped calls on mount, so racing a silent switch against those
  // proved too fragile) and let the user explicitly confirm before opening.
  // `event`, when given, anchors the confirm prompt to the clicked element
  // (see SitesService.pendingSwitch / SiteSwitchPromptComponent).
  private guardOpen(gid: number, cb: () => void, event?: MouseEvent) {
    const anchor = (event?.currentTarget as HTMLElement) || (event?.target as HTMLElement) || null;
    this.sites.requestOpen(gid, cb, anchor);
  }

  openSearchPatient(pat, event?: MouseEvent) {
    this.guardOpen(pat.GID, () => (this.selectedPatient = pat), event);
  }

  openSearchPatientHistory(pat, event?: MouseEvent) {
    this.guardOpen(pat.GID, () => {
      this.patservice.setPat(pat);
      this.rt.navigate(["/exams"], { state: { data: pat } });
    }, event);
  }

  getLocked(exam) {
    var now = new Date();
    var lockedTime = new Date(exam.Locked);
    var lock = true;
    if (
      now.getDate() != lockedTime.getDate() ||
      now.getMonth() != lockedTime.getMonth() ||
      now.getFullYear() != lockedTime.getFullYear() ||
      now.getHours() - lockedTime.getHours() > 1
    ) {
      lock = false;
    }
    if ((exam.Locked || lock) && exam.LockedBy && !this.loginService.isAdmin)
      return "locked";
    return "unlocked";
  }

  viewonly() {
    this.exServ.goExam(this.goEx.preg, this.goEx.exam, this.goEx.etype, true);
  }

  goExam(
    exam /*PID: number, examID: number, PregIndex: number, etype: string,examtime: string*/,
    event?: MouseEvent,
  ) {
    // Exam search can surface rows from other sites when the global switcher is
    // on "all" — block on a clinic mismatch first (getPatient below is itself
    // GID-scoped), same as the cross-clinic TodayList.
    this.guardOpen(exam.GID, () => {
      let preg = exam.PregIndex ? { AutoIndex: exam.PregIndex } : null;
      let id = exam.AutoIndex;
      this.patservice.getPatient(exam.PID, (s) => {
        if (s) {
          if (exam.Locked && exam.LockedBy && !this.loginService.isAdmin) return;
          let etime = new Date(exam.CreationTime);
          let now = new Date();
          if (
            exam.ExamType != "Emergency Room" &&
            ((!this.exServ.examClosed(etime) && !this.loginService.isCardio) ||
              (this.loginService.isCardio && !exam.ClosedDate)) &&
            (this.loginService.userType == "doctor" ||
              this.loginService.userType == "visitingdoc" ||
              this.loginService.userType == "tech")
          ) {
            this.showLogin = true;

            this.goEx = { preg: preg, exam: exam, etype: exam.ExamType };
            if (this.loginService.ClinicID)
              this.startClinic = this.loginService.ClinicID;
          } else this.exServ.goExam(preg, exam, exam.ExamType, s.PID);
        }
      });
    }, event);
  }
  searchClosed($event: any[]) {
    this.showExcel = true;
    if ($event && $event.length > 3) {
      this.fromd = $event[0];
      this.tod = $event[1];
      if (this.reportsNames.includes($event[3])) {
        this.examSearch($event[3], $event[4]);
      } else {
        this.examVals = $event[2];
        this.examMode = $event[3];
        this.examSearch();
      }
    }
    this.openEsearch = false;
  }
  searchXml($event: any[]) {
    this.isAWL = false;
    this.AWLlist = null;
    this.examList = null;
    this.visitPat = null;
    this.patList = null;
    this.isReports = true;
    this.reportName = $event[2];
    this.fromd = $event[0];
    this.tod = $event[1];
    this.openEsearch = false;
    this.exServ.searchReport = {
      start: this.fromd,
      end: this.tod,
      type: this.reportName,
    };
    this.xmlLoading = true;
    this.exServ.xmlReport(this.fromd, this.tod, this.reportName).subscribe(
      (data) => {
        this.xmlLoading = false;
        this.showDownLoad = true;
        this.xmlList = data;
      },
      (error) => {
        this.xmlLoading = false;
        console.log(error);
      },
    );

    console.log($event);
  }

  setAWL(pat) {
    try {
      let edate = new Date(pat.ExamDate);
      this.awlTime =
        edate.getHours() +
        ":" +
        (edate.getMinutes() < 10 ? "0" : "") +
        edate.getMinutes();
    } catch {
      this.awlTime = null;
    }
    this.awlExamType = pat.ExamCode;

    this.awlLMP = pat.ExamLMP;
    this.awlComment = pat.Reason ? pat.Reason : null;

    this.chosenAWL = pat.AWLID;
  }
  lmpGA(lmp) {
    if (!lmp) return "";
    let dt = new Date();
    let days = Math.floor(
      (dt.getTime() - Date.parse(lmp)) / (1000 * 60 * 60 * 24),
    );
    return Math.floor(days / 7) + "w " + (Math.floor(days) % 7) + "d";
  }

  saveComment(comment: string, AWLID: number) {
    this.patservice.saveAWLComment(comment, AWLID);
  }

  getcard() {
    this.card = "";
    setTimeout(() => {
      this.swipeField.nativeElement.focus();
    }, 100);
  }

  proccesscard(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) isEscape = evt.key === "Escape" || evt.key === "Esc";
    else isEscape = evt.keyCode === 27;

    if (isEscape) this.swiping = false;
    var card = this.card;
    if (this.card && this.card.length > 26 && this.card.includes("8=47"))
      //8=47 is the start of a macabi card
      card = this.card.substring(this.card.indexOf("8=47"));
    if (card && card.length > 26 && !this.cardtzsearch && !this.showpayment) {
      this.cardtzsearch = card.substring(7, 16);
      this.idcode = card.substring(6, 7);
      this.expcode = card.substring(16, 20);
      if (this.AWLStatus != "All") this.AWLStatus = "All";
      this.AWL(false);
    }
  }

  barscan(evt) {
    evt = evt || window.event;
    var isEscape = false;
    if ("key" in evt) isEscape = evt.key === "Escape" || evt.key === "Esc";
    else isEscape = evt.keyCode === 27;

    if (isEscape) this.swiping = false;

    if (
      this.card.trim().length >= 12 &&
      (!this.last_search_time || Date.now() > this.last_search_time + 5000)
    ) {
      //belinson addmission code
      this.last_search_time = Date.now();
      this.patservice.findPatBelinson(this.card.trim()).subscribe(
        (patient: Patient) => {
          if (patient) {
            this.patList = [];
            this.isAWL = false;
            let pat = new Patient();
            pat.asignVals(patient);
            this.patList[0] = pat;
            this.setAWL(pat);
            this.selectedPatient = pat;
            this.swiping = false;
            this.card = "";
            this.awlTime = new Date().toTimeString().substring(0, 5);
          }
        },
        (err) => {
          console.log(err);
        },
      );
    }
  }

  paymentNoCard() {
    this.showpayment = this.selectedPatient.ID;
    while (this.showpayment.length < 9)
      this.showpayment = "0" + this.showpayment.toString();
    this.idcode = "0";
    this.expcode = null;
  }

  ngOnDestroy(): void {
    if (this.searchSub) this.searchSub.unsubscribe();
    this.sub.unsubscribe();
    this.patservice.closeWebSocket();
    this.sites.closeSockets();
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  getStatus(status: string): string {
    //for cardio
    if (this.loginService.isCardio) {
      switch (status) {
        case "Completed":
          return "Performed";
        case "Waiting":
          return "Scheduled";
        case "Received":
          return "Waiting";
        default:
          return status;
      }
    } else return status;
  }

  setExamCode(pat) {
    var saveTitle = this.patservice.setExamCode(
      this.changedExamCode,
      pat.AWLID,
    );
    saveTitle.subscribe((res) => {
      console.log(res);
      this.changedExamCode = null;
      this.AWL();
    });
  }

  setPatAwlid(pat) {
    if (this.loginService.isGastro) {
      this.gfs.paitentLoaded$.next(pat);
    }
  }

  // Sites: open the per-clinic workload popup (waiting for interpretation, etc.).
  openSiteStats() {
    this.showSiteStats = true;
    this.siteStatsLoading = true;
    this.sites.getCounts().subscribe({
      next: (c) => { this.siteCounts = c || []; this.siteStatsLoading = false; },
      error: () => { this.siteCounts = []; this.siteStatsLoading = false; },
    });
  }

  // Drill in from the stats popup: filter the TodayList to that site and close.
  filterToSite(gid: number) {
    this.siteFilter = gid;
    this.showSiteStats = false;
    this.AWL();
  }

  // Cross-clinic TodayList open: navigate to /exams exactly as the normal
  // TodayList exit does, blocking on a clinic mismatch (or "all" mode) with an
  // explicit confirm first — see SitesService.requestOpen. Non-cross rows are
  // unaffected (template keeps routerLink).
  openAwlRow(pat, event?: MouseEvent) {
    this.guardOpen(pat.GID, () => {
      this.patservice.setPat(pat);
      this.setPatAwlid(pat);
      this.patservice.lastAwlDate = pat["ExamDate"];
      this.rt.navigate(["/exams"], { state: { data: pat } });
    }, event);
  }

  filterExams(exams, type, hmo = null) {
    if (!exams) return [];
    if (hmo)
      return exams.filter((i) => i.ExamType == type && i.HMO == hmo && i.PRN);
    return exams.filter((i) => i.ExamType == type);
  }

  export() {
    var table;
    var strTable;
    var items = ["CreationTime", "ID", "First", "Last", "HMO", "ExamType"];
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    strTable = "<tr>";
    strTable +=
      "<td> חיפוש לפי</td><td>" +
      this.getType(this.exServ.searchReport.type) +
      "</td><td>" +
      this.getHMO(this.exServ.searchReport.hmo) +
      "</td>";
    strTable += "</tr><tr></tr>";
    strTable +=
      "<tr><td>תאריכים</td><td>" +
      this.getDate(this.exServ.searchReport.start) +
      "</td><td>" +
      this.getDate(this.exServ.searchReport.end) +
      "</td></tr>";

    if (this.examList.length > 0) {
      for (let name of this.examNames) {
        var examTable = "";
        examTable += "<tr>";
        table = document.createElement("table");
        examTable += `<td>${name}</td>`;
        examTable += "</tr>";
        examTable += "<tr>";
        for (let item of items) {
          examTable += `<td><strong>${item}</strong></td>`;
        }
        examTable += "</tr>";
        examTable += "<tr>";
        for (let exam of this.filterExams(this.examList, name)) {
          for (let item of items) {
            var date;
            if (item == "CreationTime") {
              date = exam[item].replace("T", " ").replace("Z", "");

              examTable += `<td>${date}</td>`;
            } else {
              examTable += `<td>${exam[item]}</td>`;
            }
          }
          examTable += "</tr>";
        }
        table.innerHTML = strTable + examTable;
        if (this.filterExams(this.examList, name).length > 0) {
          const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(table);
          XLSX.utils.book_append_sheet(wb, ws, name);
        }
      }
      XLSX.writeFile(wb, new Date().toISOString().split("T")[0] + ".xlsx");
      this.loginService.exportLoading = false;
      this.showLogin = false;
      this.sub.unsubscribe();
    }
  }

  sendMacabi() {
    this.patservice
      .sendMacabi(
        this.fromd["_i"].year +
          "-" +
          (this.fromd["_i"].month + 1 < 10 ? "0" : "") +
          (this.fromd["_i"].month + 1) +
          "-" +
          (this.fromd["_i"].date < 0 ? "0" : "") +
          this.fromd["_i"].date,
        this.tod["_i"].year +
          "-" +
          (this.tod["_i"].month + 1 < 10 ? "0" : "") +
          (this.tod["_i"].month + 1) +
          "-" +
          (this.tod["_i"].date < 0 ? "0" : "") +
          this.tod["_i"].date,
      )
      .subscribe(
        (data) => {
          this.sentMacabi = true;
        },
        (err) => {
          console.log(err);
        },
      );
  }

  getHMO(hmo) {
    switch (hmo) {
      case "Macabi":
        return "מכבי";
      case "Leumit":
        return "לאומית";
      case "Meuhedet":
        return "מאוחדת";
      case "Clalit":
        return "כללית";
      case "Private":
        return "פרטי";
      case "IDF":
        return "צהל";
      case "null":
        return "לא שוייכו";
      default:
        return "הכל";
    }
  }
  getType(type) {
    switch (type) {
      case "Macabi":
        return "בדיקות שנשלחו למכבי";
      case "HMO":
        return "קופת חולים";
      case "Refferelnum":
        return "מס' הפניה חסר";
      default:
        return "הכל";
    }
  }
  getDate(date) {
    var temp = new Date(date);
    var str =
      temp.getDate() + "/" + (temp.getMonth() + 1) + "/" + temp.getFullYear();
    return str;
  }

  startForm(pat) {
    this.exServ.patServ.setPat(pat);
    this.exServ.concentForm = null;
    var res = this.exServ.getConcentForms(pat.PID);
    res.subscribe((data: any) => {
      console.log(data);
      if (!data.hasOwnProperty("empty")) {
        var temp = data.filter((i) => i.ExamType == pat.ExamCode && !i.ExamID);
        if (
          pat.ExamCode.split(" ")[1] == "Anatomy" ||
          pat.ExamCode.split(" ")[1] == "Trimester"
        )
          var temp = data.filter(
            (i) => i.ExamType == pat.ExamCode.split(" ")[0] && !i.ExamID,
          );
        if (temp.length > 0) {
          this.concentForm = temp[0];
        } else {
          this.exServ.concentForm = null;
          this.exServ.examID = null;
          this.exServ.pregId = null;
          this.exServ.pregnancies = null;
          this.concentForm = null;
        }
      } else {
        this.exServ.examID = null;
        this.exServ.pregId = null;
        this.exServ.pregnancies = null;
        this.exServ.concentForm = null;
        this.concentForm = null;
      }
      this.inform = true;
    });
  }
  getDoctors() {
    return this.loginService.clinicUsers;
  }

  /*reassign(){//move pat and todaylist to another doctor
    this.toreassign.UID = this.toreassign.nUID;
    this.toreassign.nUid = this.toreassign.UID;
    this.patservice.reassign(this.toreassign).subscribe((data)=>{
      this.toreassign = null;
      this.AWL();
    },(error)=>{
      this.toreassign = null;
      this.AWL();
      console.log(error)
    })
  } */ //geting rid of this

  closCalForm(event) {
    this.inform = false;
  }

  getDbName(i, str) {
    var t = i.replace("-", "").split(" ")[0];

    return str + t;
  }

  getIDF() {
    window.open(
      "/api/cardio/idf/" +
        this.datePipe.transform(this.fromd, "yyyy-MM-dd") +
        "/" +
        this.datePipe.transform(this.tod, "yyyy-MM-dd"),
    );
  }

  downloadXml(hmo: string = "Clalit") {
    const downloadUrl = `/api/eyes/downloadXmls/${hmo}`;
    this.exServ.downloadXmls(downloadUrl).subscribe(
      (response) => {
        // Extract the filename from the content-disposition header
        const contentDisposition = response.headers.get("content-disposition");
        const filename = contentDisposition.split(";")[1].trim().split("=")[1];

        // Create an object URL for the blob
        const blob = new Blob([response.body], { type: "application/zip" });
        const url = window.URL.createObjectURL(blob);

        // Create a link element and click it to trigger the download
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();

        // Clean up
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.showDownLoad = false;
      },
      (error) => {
        // Handle error
        console.error("Failed to download ZIP file:", error);
      },
    );
  }

  exporXmlList() {
    const startDate = this.exServ.parseDateDayMonthYear(this.fromd);
    const endDate = this.exServ.parseDateDayMonthYear(this.tod);

    const filteredData = this.xmlList.map((item) => ({
      "Exam Time": item.CreationTime,
      ID: item.ID,
      Name: `${item.First} ${item.Last}`,
      "Exam Type": `${item.ExamType} ${item.Changed ? `(${item.ChangedExamTitle})` : ""}`,
      "Xml File Name": item.xmlName,
    }));

    const sheetName = "Report";
    const fileName = `xml generated list from ${startDate} to ${endDate}.xlsx`;
    const worksheet = XLSX.utils.json_to_sheet(filteredData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, fileName);
  }

  generateXlExams(exams) {
    const datePipe = new DatePipe("en-US");
    let docName;
    if (!this.loginService.isAdmin) {
      docName = this.loginService.username;
    } else {
      docName = this.loginService.getDocByUID(this.loginService.doctor);
    }
    if (!docName) docName = "כולם";

    let clinicName = this.loginService.Clinic;
    const filteredData = exams.map((item) => ({
      "תאריך הבדיקה": datePipe.transform(item.CreationTime, "dd-MM-yyyy"),
      "ת.ז של הנבדק/ת": item.ID,
      "שם הנבדק/ת": `${item.First || ""} ${item.Last || ""}`,
      קופה: item.HMO || "",
      "סוג הבדיקה": item.ExamType,
      "שם פותח הבדיקה": item.OpenerName,
      "נחתם על ידי": item.TerminationRemarks || "",
      "נחתם בתאריך": item.TerminationDate
        ? datePipe.transform(item.TerminationDate, "dd-MM-yyyy")
        : "",
    }));

    const totalExams = filteredData.length;
    const totalSignedExams = exams.filter((e) => e.TerminationRemarks).length;
    const totalNotSignedExams = totalExams - totalSignedExams;

    // ספירת בדיקות חתומות לפי רופא
    const doctorSignedCount = {};
    exams.forEach((exam) => {
      if (exam.TerminationRemarks) {
        const doctorName = exam.TerminationRemarks;
        doctorSignedCount[doctorName] =
          (doctorSignedCount[doctorName] || 0) + 1;
      }
    });

    // ספירת בדיקות חתומות לפי רופא וסוג בדיקה
    const doctorExamTypeCount = {};
    exams.forEach((exam) => {
      if (exam.TerminationRemarks) {
        const doctorName = exam.TerminationRemarks;
        const examType = exam.ExamType || "Unknown";
        const key = `${doctorName}|${examType}`;
        doctorExamTypeCount[key] = (doctorExamTypeCount[key] || 0) + 1;
      }
    });

    const startDate = this.exServ.parseDateDayMonthYear(this.fromd);
    const endDate = this.exServ.parseDateDayMonthYear(this.tod);

    const sheetName = "examsList";
    const fileName = `exams generated list from ${startDate} to ${endDate}.xlsx`;

    const worksheet = XLSX.utils.json_to_sheet([]);

    XLSX.utils.sheet_add_aoa(worksheet, [[clinicName]], { origin: "A1" });
    XLSX.utils.sheet_add_aoa(worksheet, [[`שם הרופא: ${docName}`]], {
      origin: "A2",
    });

    XLSX.utils.sheet_add_json(worksheet, filteredData, { origin: "A4" });

    // הוספת סיכום בדיקות חתומות לפי רופא
    let summaryRow = 5 + filteredData.length;
    XLSX.utils.sheet_add_aoa(
      worksheet,
      [
        [
          `סה"כ בדיקות: ${totalExams}`,
          `סה"כ בדיקות חתומות: ${totalSignedExams}`,
          `סה"כ בדיקות לא חתומות: ${totalNotSignedExams}`,
        ],
      ],
      { origin: "A3" },
    );

    // הוספת ספירת בדיקות לפי רופא
    summaryRow += 2;
    XLSX.utils.sheet_add_aoa(worksheet, [["בדיקות חתומות לפי רופא"]], {
      origin: `A${summaryRow}`,
    });
    summaryRow += 1;
    Object.entries(doctorSignedCount).forEach(([doctor, count]) => {
      XLSX.utils.sheet_add_aoa(worksheet, [[doctor, count]], {
        origin: `A${summaryRow}`,
      });
      summaryRow += 1;
    });

    // הוספת ספירת בדיקות לפי רופא וסוג בדיקה
    summaryRow += 2;
    XLSX.utils.sheet_add_aoa(
      worksheet,
      [["בדיקות חתומות לפי רופא וסוג בדיקה"]],
      { origin: `A${summaryRow}` },
    );
    summaryRow += 1;
    XLSX.utils.sheet_add_aoa(worksheet, [["רופא", "סוג בדיקה", "כמות"]], {
      origin: `A${summaryRow}`,
    });
    summaryRow += 1;
    Object.entries(doctorExamTypeCount).forEach(([key, count]) => {
      const [doctor, examType] = key.split("|");
      XLSX.utils.sheet_add_aoa(worksheet, [[doctor, examType, count]], {
        origin: `A${summaryRow}`,
      });
      summaryRow += 1;
    });

    worksheet["!cols"] = [{ wch: 30 }];
    const columnCount = Object.keys(filteredData[0] || {}).length;
    worksheet["!cols"] = Array(columnCount).fill({ wch: 30 });
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheetName);
    writeFile(workbook, fileName);
  }

  redirectAdministration(type) {
    this.http.post("/api/administration", { type }).subscribe((data: string) => {
      window.location.href = data;
    });
  }

  openSendQuestionnaire(pat: any) {
    this.sendQuestionnairePatient = pat;
    this.showSendQuestionnaire = true;
  }

  // AR-24: mark today-list patients who have already answered a questionnaire,
  // so a green check badge can be shown on the questionnaire icon.
  private loadQuestionnaireStatuses(patients: any[]): void {
    if (!(this.loginService.premissions && this.loginService.premissions.Questionnaires)) return;
    this.patQuestionnaireAnswered = {};
    for (const pat of patients) {
      if (!pat?.PID || !pat?.AWLID) continue;
      this.exServ.getPatientQuestionnaires(pat.PID).subscribe((data: any) => {
        const items = (data && data.items) || [];
        const answered = items.some(
          (i: any) => i.answeredDate && (!pat.ExamCode || i.examCode === pat.ExamCode)
        );
        if (answered) this.patQuestionnaireAnswered[pat.AWLID] = true;
      });
    }
  }

  openHelp() {
    const rawPath = "/assets/pdf/eyes_guide.pdf";
    const encodedPath = encodeURI(rawPath);
    const fullUrl = window.location.origin + encodedPath;

    window.open(fullUrl, "_blank");
  }
}
